
export type EventCallback = (event: { data: string }) => void;
export type ErrorCallback = (error: any) => void;

export interface CustomEventSourceOptions {
    params?: string | string[][] | Record<string, string> | URLSearchParams | undefined
    headers?: Record<string, string>
}

export class CustomEventSource {
    private readonly url: string;
    private readonly options: CustomEventSourceOptions
    private readonly controller: AbortController;
    public onmessage: EventCallback | null = null;
    public onerror: ErrorCallback | null = null;

    constructor(url: string, options: CustomEventSourceOptions = {}) {
        this.url = url;
        this.options = options;
        this.controller = new AbortController();
        this.init();
    }

    private async init(): Promise<void> {
        try {
            const response = await fetch(this.url + "?" + (new URLSearchParams(this.options.params ?? {})).toString(), {
                method: 'GET',
                headers: {
                    ...(this.options.headers ?? {}),
                    'Accept': 'text/event-stream'
                },
                signal: this.controller.signal
            });

            const reader = response.body?.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';

            if (!reader) throw new Error('ReadableStream not supported');

            while (true) {
                const {done, value} = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, {stream: true});
                const lines = buffer.split("\n\n");
                buffer = lines.pop() || '';

                for (const line of lines) {
                    this.onmessage?.({data: line.substring("data: ".length)});
                }
            }
        } catch (error) {
            this.onerror?.(error);
        }
    }

    public close(): void {
        this.controller.abort();
    }
}
